<div class="h-[80px] bg-brand-900 px-[60px] py-32">
  <div class="text-center text-body-xs-400 text-secondary-greys-white">© {{ date }} CRH. All Rights Reserved.</div>
</div>
